import CreateProductPromotion from "./CreateProductPromotion";

export default CreateProductPromotion;